
import React from "react";
import "./Contact.css";

const Contact = () => {
  return (
    <div className="contact-container">
      <h2>Contact Me</h2>

      {/* Contact Form */}
      <form
        action="https://formspree.io/f/xwpkoyyj"
        method="POST"
        className="contact-form"
      >
        <input
          type="text"
          name="name"
          placeholder="Your Name"
          required
        />
        <input
          type="email"
          name="email"
          placeholder="Your Email"
          required
        />
        <textarea
          name="message"
          placeholder="Your Message"
          required
        ></textarea>
        <button type="submit">Send Message</button>
      </form>

      <div className="calendly-container">
  <h3>Schedule a Meeting</h3>
  <p>Click below to book a session at your convenience.</p>
  <a 
    href="https://calendly.com/maryannichaura/30min" 
    target="_blank" 
    rel="noopener noreferrer" 
    className="calendly-button"
  >
    Book a Meeting
  </a>
</div>
    </div>
  );
};

export default Contact;
